import React, { useContext, useEffect, useRef } from 'react'
import fetch from 'isomorphic-unfetch'
import getUrl from 'lib/url'
import { GlobalStoreContext } from 'Components/store'
import { teaConfig, sendTeaCommEvent } from 'lib/tea-analyze'
import { LoginStoreContext } from 'New/login/login-store'
import Avatar, { ugcUserLink } from 'Components/author/avatar'
import ToolTip from 'Components/new/tool-tip'
import style from './new-user.module.scss'

const fetchAntiToken = () => {
  return fetch(getUrl('/tt-anti-token'))
    .then((res) => res.json())
    .then((res) => {
      window.localStorage.setItem('tt-anti-token', res?.data?.token || '')
    })
    .catch((err) => {
      console.error(err)
    })
}

export default function User(props: any) {
  const { size, isFixed } = props
  // 设置全局的城市
  const { state: globalStore } = useContext(GlobalStoreContext)
  const { userData } = globalStore

  useEffect(() => {
    if (!userData) {
      fetchAntiToken()
    }
  }, [userData])

  const isLogin = userData && userData.user_id
  const screenName = (userData && userData.screen_name) || ''

  useEffect(() => {
    if (userData?.user_id) {
      sessionStorage.setItem('userData', JSON.stringify(userData))
      teaConfig({
        user_id: userData.user_id,
      })
    }
  }, [userData?.user_id])

  const { openLogin, logout } = useContext(LoginStoreContext)

  const closeRef = useRef<() => void>()

  useEffect(() => {
    if (isFixed) {
      if (closeRef.current) {
        closeRef.current()
      }
    }
  }, [isFixed])

  return isLogin ? (
    <ToolTip
      tag={'div'}
      theme={'light'}
      arrowVisible={false}
      placement={'bottom-end'}
      content={({ close }) => {
        closeRef.current = close
        return (
          <ul className={style['dropdown-panel']}>
            <li className={style['dropdown-item']}>
              {ugcUserLink({ userId: userData?.user_id, target: '_self' })(
                <div className={style['user-wrapper']}>
                  <Avatar
                    avatar={userData?.avatar_url}
                    username={userData?.name}
                    size={36}
                  />
                  <div
                    className={style['username-wrapper']}
                    onClick={() => {
                      sendTeaCommEvent('clk_event', {
                        event_id: 'common_login_menu_item',
                        button_name: '个人主页',
                      })
                    }}
                  >
                    <p className="username">{screenName}</p>
                  </div>
                </div>
              )}
            </li>
            <li className={style['dropdown-item']}>
              <span
                className="g-active-link-text"
                onClick={() => {
                  sendTeaCommEvent('clk_event', {
                    event_id: 'common_login_menu_item',
                    button_name: '退出登录',
                  })
                  logout()
                }}
              >
                <i className={style['ic-logout']} />
                退出登录
              </span>
            </li>
          </ul>
        )
      }}
    >
      <Avatar
        avatar={userData?.avatar_url}
        username={userData?.name}
        size={36}
        onClick={() => {
          sendTeaCommEvent('clk_event', {
            event_id: 'common_user_profile_icon',
          })
        }}
      />
    </ToolTip>
  ) : (
    <button
      type="button"
      className={style['login-btn']}
      onClick={() => {
        openLogin({
          enter_method: 'login',
        })
        sendTeaCommEvent('clk_event', {
          event_id: 'common_login_icon',
        })
      }}
    >
      登录
    </button>
  )
}
